import { Box, StandardProps } from '@mui/material';
import moment from 'moment';

interface DurationProps extends StandardProps<HTMLElement, 'root'> {
  duration: number;
  unit?: 'ms' | 's';
  classes?: any;
}

function Duration(props: DurationProps) {
  let { duration, unit } = props;
  if (unit === 's') {
    duration = duration * 1000;
  }

  // 转换成毫秒
  const hh = moment.duration(duration, 'ms').hours() + '';
  const mm = moment.duration(duration, 'ms').minutes() + '';
  const ss = moment.duration(duration, 'ms').seconds() + '';
  const format =
    hh.padStart(2, '0') + ':' + mm.padStart(2, '0') + ':' + ss.padStart(2, '0');

  return (
    <Box
      className={props.className}
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      {format}
    </Box>
  );
}

Duration.defaultProps = {
  unit: 'ms',
} as Partial<DurationProps>;

export default Duration;
